import { Defaults } from 'es-decorators'
import 'es6/libs/textarea-autosize'
import { dateFormat, timeFormat } from 'helpers/date-helpers'
import { getTemplate } from 'helpers/template-helper'
import $ from 'init/jquery'
import 'es6/libs/owl-carousel'
import { prepareStringWithLinks } from 'helpers/string-helpers'
import { View } from 'es6/components/view'
import { Model } from 'es6/components/model'
import isString from 'lodash/isString'
import isEmpty from 'lodash/isEmpty'

/**
 * Вид для одного вопроса в новостях
 */
@Defaults({
  templateSelector: '#product-question-template',
  answerTemplateSelector: '#news-comment-reply-template',
  additionalOptions: ['isMobile', 'templateSelector', 'answerTemplateSelector', 'resolveReplies'],
})
class NewsQuestionView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.template = getTemplate(this.templateSelector)
  }

  /**
   * Рисуем вопрос
   * @returns {NewsQuestionView} вопросы
   */
  render () {
    const model = this.model.toJSON()
    let templateData = {
      model,
      humanDate: dateFormat,
      timeFormat: timeFormat,
      isAuth: this.user.has('id'),
      initialQuestionId: this.model.id,
      currentUserId: this.user.get('id'),
      messageData: prepareStringWithLinks(model.message),
    }

    const element = $(this.template(templateData))
    this.$el.replaceWith(element)
    this.setElement(element)

    this._renderReplies(this.resolveReplies(this.model))
    return this
  }

  /**
   * Отрисовка ответов.
   * @param {Array} replies
   * @private
   */
  _renderReplies (replies) {
    const $container = this.$('.js-answers-block')
    if (!isEmpty(replies)) {
      if (Array.isArray(replies)) {
        replies.forEach(reply => {
          if (reply.message) {
            $container.append(this.createQuestionView(new Model(reply)))
          }
        })
      } else if (isString(replies)) {
        $container.append(this.createQuestionView(new Model({ message: replies })))
      }
    }
  }

  /**
   * Инициализация view и отрисовка ответов.
   * @param {Object} model вопроса
   * @returns {HTMLElement} рендер view элементов
   */
  createQuestionView (model) {
    const view = new NewsQuestionView({
      model,
      user: this.user,
      isMobile: this.isMobile,
      templateSelector: this.answerTemplateSelector,
    })
    this.childViews.questions = this.childViews.questions || []
    this.childViews.questions.push(view)
    return view.render().el
  }

  /**
   * Возвращает ответы переданной модели вопроса.
   * @param {Model} model Модель.
   * @returns {Array} Ответы.
   */
  resolveReplies (model) {
    return model instanceof Model ? model.get('answers') : []
  }
}

export default NewsQuestionView
